module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "chap-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-5"
    }
  }, [_vm._v("WHAT YOU"), _c('br'), _vm._v("NEED TO KNOW")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-5"
    }
  }, [_c('span', {
    staticClass: "let"
  }, [_c('i', [_vm._v("I")])]), _vm._v(" "), _c('b', [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("REALIZE NOW HOW VERY BRAVE")])])]), _vm._v(" and a little foolish it all really was.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-5"
    }
  }, [_vm._v("On an otherwise ordinary afternoon in the autumn of 2001, I waited for her to walk down the aisle and join me at the altar. Twelve hours earlier, I’d awoken in the muted hours before dawn to transport a special bottle of champagne from my hotel to the office of our limo company. I had been mostly alone on the vacant highways. I’d done this by myself because it never occurred to me to ask for help. In those days, I was used to traveling through life alone.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-5"
    }
  }, [_vm._v("Alone was all I’d ever known.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-5"
    }
  }, [_vm._v("Then the doors opened and there she was, moving toward me. Time has taken from memory most of what followed, but I can still clearly remember how "), _c('i', [_vm._v("happy")]), _vm._v(" she looked walking down that aisle. Somehow I knew her happiness wasn’t about her big day having finally arrived. She’s not a center-of-attention kind of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-6"
    }
  }, [_vm._v("person, and she’s not a waiting-for-prince-charming kind of woman. Rather, I knew her happiness was simply about marrying me. On the surface, I acted like this made perfect sense. I liked to pretend—even to myself sometimes—that I was quite a catch. However, underneath the bravado I was still confused about why a woman like her would tether herself to a guy like me.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-6"
    }
  }, [_vm._v("Then, she was there. Next to me. "), _c('i', [_vm._v("With")]), _vm._v(" me. And in the moments that followed, I pledged the remainder of my life to her. Wedding vows are a little startling, if you are paying any kind of attention at all. I promised I’d stick by her through all sorts of catastrophe—poverty, illness, her death, or mine. Just a few weeks earlier, the Twin Towers had been reduced to a tragic pile of steel and stone. The rubble was still smoldering as my bride and I promised to stick by each other through buildings falling and bodies failing. To promise that kind of no-matter-whatness when you are twenty-some years old and living in a world on fire, you have to be a little foolish or a lot courageous. I think there was a bit of both in our vows that day. Yet, my wedding-day promise was not nearly the bravest thing I’d ever said to her.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-6"
    }
  }, [_vm._v("Nine months after our first date, I had confessed to her for the first time.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-6"
    }
  }, [_vm._v("Until then, I’d mostly just been putting on a show, trying hard to look confident, calm, and collected on the outside. Meanwhile, on the inside, the deep reservoir of anxiety I’d managed to keep hidden within me for most of my life was beginning to rise. The dam was breaking, and some of the anxiety was leaking out through my body. For instance, the inside of my mouth was so plagued by stress-induced cold sores I could barely eat with her, let alone kiss her. I’d kept her oblivious to all of it, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-7"
    }
  }, [_vm._v("though, because I was pretty sure “cold sores” was not one of the boxes she hoped to check in her search for a companion.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-7"
    }
  }, [_vm._v("Then one morning, the dam finally broke for good. I decided I couldn’t hide my suffering any longer. I sat her down, and with my head in my hands, I wept while telling her the truth. It was the bravest thing I’d ever done, to risk losing who I loved by being who I was. Again, time has washed away most of my memory about how all that truth flowed out of me. What I "), _c('i', [_vm._v("do")]), _vm._v(" remember is how she filled me back up with four little words: “We’ll figure it out.” It was the first vow she ever made to me, and it was, I think, my first taste of true companionship. A month later I started shopping for a ring. By the end of the summer we were engaged, and a little more than a year later we were standing at that altar, making promises that are awfully complicated to keep.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-7"
    }
  }, [_vm._v("ABOUT THIS BOOK")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-7"
    }
  }, [_vm._v("When I began writing this book, I thought it was about saving this ancient institution called marriage. Seriously. I planned to right this sinking ship we call matrimony by convincing a whole generation of young people to quit jumping ship, to head to the courthouse, and to set sail upon the kind of life-changing journey marriage can become. Plus, “marriage books” sell like hotcakes. It all seemed like a very good idea.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-7"
    }
  }, [_vm._v("Then, one day, a friend pushed back.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-7"
    }
  }, [_vm._v("She asked about my next book, and when I told her what it was about, her face fell. “I love your writing,” she explained, “but I can’t pick up any book with marriage on the cover.” She is a single woman. Men have been cruel to her. An uninterested "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-8"
    }
  }, [_vm._v("father. A boyfriend who abandoned her in the middle of a pregnancy. A husband who drank their marriage to death. Now, she has the courage to stand alone while raising her young daughter on her own. She still hopes to marry again, but she has become less willing to settle for more of the same from the men in her life. In other words, for now, she doesn’t have a ticket for the marriage cruise, and she isn’t interested in reading about the poolside piña coladas.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-8"
    }
  }, [_vm._v("I can’t blame her. So, I wrote this book for her and for everyone like her. It’s a book about a cruise we are, all of us, already on. This is a book about marriage that is also about something "), _c('i', [_vm._v("bigger")]), _vm._v(" than marriage. In her Pulitzer Prize–winning novel, "), _c('i', [_vm._v("Gilead")]), _vm._v(", Marilynne Robinson writes, “The moon looks wonderful in this warm evening light, just as a candle flame looks beautiful in the light of morning. Light within light. . . . It seems to me to be a metaphor for the human soul, the singular light within the great general light of existence. Or it seems like poetry within language. Perhaps wisdom within experience. Or marriage within friendship and love.” What if marriage is a singular light within the great general light of "), _c('i', [_vm._v("companionship, ")]), _vm._v("but we keep trying to turn it into the big light itself? What if uncovering the secrets to a stellar marriage isn’t as important as finding our way to the truths at the heart of true companionship? This book is about the great general light of companionship, inside which marriage flickers and flames.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-8"
    }
  }, [_vm._v("If I could, I’d go back in time and join my younger self in the early morning hours of his wedding day. I’d ride with him on that empty highway, with that bottle of champagne resting on the seat between us, and I’d tell him things he couldn’t possibly "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-9"
    }
  }, [_vm._v("fathom yet. I’d tell him marriage is relatively simple. It’s a signature on a license at the courthouse, a benediction from the pastor, a kiss, a bunch of rice stuck in hair he won’t have for much longer, a rowdy reception, and years and anniversaries rolling by, until one day the rolling finally stops.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-9"
    }
  }, [_vm._v("But, I’d tell him, "), _c('i', [_vm._v("companionship")]), _vm._v(" is something he already began, on a painful morning of confession months before. I’d tell him companionship is anything but simple. It’s hard work. It takes guts and perseverance. It’s a long walk through "), _c('i', [_vm._v("everything")]), _vm._v(": sorrow and celebration, heartbreaking disappointment and heartwarming contentment, all sorts of uncertainty and a moment of clarity here and there. It takes everything you’ve got, and sometimes it gives you back more than you could ever hope for. It is a four-word vow lived out in the midst of our hardest humanity:")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-9"
    }
  }, [_vm._v("We’ll figure it out.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-9"
    }
  }, [_vm._v("I’d tell him marriage is one very special candle that can burn within the big, bright light of companionship. Friendship is another one, of course, as is the relationship between a parent and a child, or the relationship between siblings. Really, wherever two or more are gathered, a little more light can be added to the great general light of companionship. I’d tell him he has spent much of his life thinking about how to get better at marriage and that might make him better at being married, but getting better at "), _c('i', [_vm._v("companionship")]), _vm._v(" will make him better at being "), _c('i', [_vm._v("human")]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-9"
    }
  }, [_vm._v("Then, he’d drop off the champagne at the limo office, where the lone attendant will look at him like he’s nuts, and we’d drive back to the hotel together. On the way, I’d be sure to tell him what I witnessed last Thanksgiving Day in a buffet line at a local inn. While someone ahead of me contemplated corn versus carrots, I had time to stand there with an empty plate and observe, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-10"
    }
  }, [_vm._v("through two panes of glass, the line moving a little more quickly on the other side of the buffet.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-10"
    }
  }, [_vm._v("What I saw was two companions.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-10"
    }
  }, [_vm._v("I’m guessing they were in their early seventies, but something had happened to him. A stroke perhaps, or something nearly as catastrophic. His age was seventy-something, but his body was ninety-something. He slouched heavily with both hands on a walker in front of him, inching it forward with great effort, muscle tone almost completely missing. Large hearing aids were perched in both ears. With both hands on his walker, he was unable to reach for his own food. So she walked behind him, reaching for both of them.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-10"
    }
  }, [_vm._v("They were figuring it out.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-10"
    }
  }, [_vm._v("I watched as they slowly moved by the mashed potatoes and the stuffing and a bowl full of something made of marshmallows. She would serve herself and then lean over, with her mouth close to his ears, pointing at each pile of food, asking him if he wanted it. Sometimes he would nod. Sometimes he wouldn’t. Slowly, his plate filled up. It was all very hushed. I could not hear a word of it. Usually, companionship isn’t loud and fancy and intoxicating like a wedding celebration. It’s quiet and plodding and nourishing. I’d tell my younger self that I don’t know if the couple was married. They probably were. But I "), _c('i', [_vm._v("do")]), _vm._v(" know they were companions.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-10"
    }
  }, [_vm._v("ABOUT UNCONDITIONAL LOVE")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-10"
    }
  }, [_vm._v("By then, we’d probably be pulling back into the hotel. He’d have vows to finish writing and would be eager to get on with "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-11"
    }
  }, [_vm._v("his day, but I’d ask him to linger with me just a little longer. There’s one more thing I need to tell him. It’s about love. It will probably shock him, but that’s why he needs to hear it. It’s too counterintuitive and too important to be left unsaid. I’d start out by telling him about a fight he’s going to have with his bride—seventeen years in the future.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-11"
    }
  }, [_vm._v("It was less like a lovers’ quarrel and more like an American Civil War battle, the kind where you declare a ceasefire at sundown, go back to your tents for the night, and resume in the morning after breakfast—the kind of fight that can last for a week, or weeks. It all started when she pointed out that I was “checking out.” Around bedtime—when the kids most long for a father to come to them and see them and send them into their sleep—I was scrolling through my phone, checking email, returning texts, catching up on news, getting lost down YouTube rabbit holes. Basically, she told me I was digitally abandoning my family.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-11"
    }
  }, [_vm._v("What I "), _c('i', [_vm._v("heard")]), _vm._v(" her say, though, was that I wasn’t doing enough. So, I made a list of everything I had done for the family that week. Nothing was too big or too small to be included. Then, I went to my computer, and I typed it out. I actually did that. With differently sized fonts, some items boldfaced, some italicized, like I was preparing a proposal to a board of directors. After the kids were all in bed, I handed her the list.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-11"
    }
  }, [_vm._v("Cue Gettysburg.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-11"
    }
  }, [_vm._v("For about a week, I used my words like bayonets, and her eyes were muskets. Neither one of us was willing to retreat. She insisted bedtime books were not too much to ask from a dad who writes blogs and books about being an attentive father, and I refused to hear it as anything but unfair criticism. Eventually, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-12"
    }
  }, [_vm._v("one morning, we went on a long walk—so we could battle in front of our neighbors rather than our kids—and we reached a truce. Once all the treaties were signed, I was eventually able to identify the culprit behind the whole conflict.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-12"
    }
  }, [_vm._v("Unconditional love.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-12"
    }
  }, [_vm._v("Our fight had started because she had not loved me unconditionally. There were limitations to what she would put up with. Things I do she’d like to see stop. Things I don’t do she’d like to see begin. Expectations for how I will act and live and love. "), _c('i', [_vm._v("Conditions")]), _vm._v(", if you will, for her approval. I had called her out on her conditionality, and she had called me out on defending myself with high-minded ideas arising less from my desire to be perfectly loved than from my desire to be loved "), _c('i', [_vm._v("as if I am perfect")]), _vm._v(". Sometimes, I’ll fight a whole war before admitting she is right.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-12"
    }
  }, [_vm._v("Of course, aspiring to unconditional love is a noble thing. Sitting in that parking lot on his wedding day, I’d want my younger self to know I’m not trying to undo anything he’s learned in church or anywhere else about unconditional love. I firmly believe unconditional love is that from which we came and that to which we will return. What I’m suggesting is, noble things in human hands can quickly become not-so-noble. What I’m saying is, we don’t need anyone to undo what we’ve been taught about unconditional love, because "), _c('i', [_vm._v("we")]), _vm._v(" undo it ourselves, oftentimes "), _c('i', [_vm._v("while")]), _vm._v(" we are being taught it. When our pastor or priest or whoever has the pulpit in our life begins talking about unconditional love, we often begin tweaking the ideas in favor of our justification rather than our "), _c('i', [_vm._v("transformation")]), _vm._v(". We often use it to make love easier instead of truer.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-12"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-13"
    }
  }, [_vm._v("For instance, we often hide our failures, flaws, and foibles behind it, demanding to be loved unconditionally under conditions no one should be expected to tolerate, let alone love. Or, in the name of loving someone unconditionally, we tend to forgive and forget things that should be confronted and condemned. We circumvent conflict and cut corners on the hardest parts of cultivating companionship because conflict scares us and corners cost us, and then we call those shortcuts unconditional love. Or, rather than engaging in the hard work of loving hard people, we steer clear of them, piously “accept” them, pat ourselves on the back for being tolerant, and congratulate ourselves for loving unconditionally. The thing about unconditional love—the thing that makes it something less than the cure-all we often want it to be—is that it can happen from "), _c('i', [_vm._v("very, very far away")]), _vm._v(". From somewhere up in the heavens even.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-13"
    }
  }, [_vm._v("Yet, not even God acted as if that kind of love was sufficient for true relationship. Even God decided unconditional love lacked something a little more proximal, something like skin, something like a body and a heartbeat and a pulse, something like a voice to bless with and a voice to berate with, something like arms for embracing each other and fingers for pointing "), _c('i', [_vm._v("at ")]), _vm._v("each other. Even God knew he had to come closer to us than unconditional love would require of him. So, on a silent night in a little town called Bethlehem, he did. In a manger, love came close.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-13"
    }
  }, [_vm._v("I’m guessing my younger self would be all ears now, his unfinished vows forgotten for the moment. I’d ask him if he can see how easy it is to make unconditional love into an easy thing. He’d nod. I’d tell him he’ll be tempted again and again to use "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-14"
    }
  }, [_vm._v("unconditional love as a cop-out. I’d encourage him to choose something more "), _c('i', [_vm._v("engaged")]), _vm._v(" than unconditional love. Something "), _c('i', [_vm._v("closer")]), _vm._v(". Something with molecules and guts and grit in it. He’d ask me what that something might be. And I’d tell him about his future son’s bedroom.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "p14"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-14"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/sep_autre.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-14"
    }
  }, [_vm._v("Several months after our Gettysburg week, my wife asked me to join her at the doorway to our son Quinn’s room. I peered in with her, and I saw a half-dozen odorous, preteen socks strewn across the floor, a basket of clean clothes that had been toppled and tossed across the room, a LEGO creation that had been demolished and spread underfoot, and a mad mishmash of other odds and ends. As we gazed upon the carnage, she said, with an equal mixture of wonder and anger, that she had ordered him to clean it up, and he had implied the mission was accomplished. I stood there with her, surveying the spectacle, not understanding her purpose in calling me to her. I asked her if she wanted help cleaning it up. No, she said, that’s his job. Did she want me to give him consequences for ignoring her and—kinda sorta—lying to her? No, she said, she had started this and she could finish it.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-14"
    }
  }, [_vm._v("So, we stood in silence and stared at it. I saw empty candy wrappers, a glass full of something rancid, a desiccated apple core, and the home phone that had gone missing a couple of days earlier. After a few more moments of silence, I finally asked the question, “Why did you want me here?”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-14"
    }
  }, [_vm._v(" Without taking her eyes off the mess, she put her arm around me and responded, simply, “I just wanted you to witness it with me.” Her words made me recall something I’d been reading "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-15"
    }
  }, [_vm._v("about and sharing with her. In English, we have only one word for love, but in the Greek language there are four words for love: "), _c('i', [_vm._v("agape")]), _vm._v(", "), _c('i', [_vm._v("eros")]), _vm._v(", "), _c('i', [_vm._v("storge")]), _vm._v(", and "), _c('i', [_vm._v("philia")]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-15"
    }
  }, [_c('i', [_vm._v("Agape")]), _vm._v(" love is unconditional and often considered the highest and most noble love in the Greek language. It is the kind of love that keeps on loving even when the other is cruel, offensive, or unresponsive. It is sacrificial, in the sense that it will persist no matter what. It is the kind of love we have come to expect from a loving God, and in the Greek language it is used almost exclusively to describe being divine, not being human.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-15"
    }
  }, [_c('i', [_vm._v("Eros")]), _vm._v(", on the other hand, is sort of the opposite. Whereas "), _c('i', [_vm._v("agape")]), _vm._v(" is steadfast and enduring, "), _c('i', [_vm._v("eros")]), _vm._v(" is passionate and more fleeting. "), _c('i', [_vm._v("Eros")]), _vm._v(" is about chemistry and desire. It is the delightful euphoria in any budding romance. Over time, though, its energy cannot be sustained. When it is balanced by other kinds of love, it recedes into the depths of a relationship, arising more occasionally during punctuated moments of merging. However, when it is out of balance, it can become selfish and may go searching elsewhere for the satisfaction it demands.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-15"
    }
  }, [_c('i', [_vm._v("Storge")]), _vm._v(", then, stands in contrast to "), _c('i', [_vm._v("eros")]), _vm._v(". It is dispassionate. But it is also devoted. It is quietly loyal. It doesn’t require much effort, because it arises naturally, an affection born out of family ties and shared amongst kin. It’s about an identity that transcends the self and feels like a given. An inheritance. It is the glue that holds tribes together. It is the kind of love the Hatfields had for one another, and the kind of love the McCoys had for one another, and the kind of love that meant no love was lost between the two families.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-15"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-16"
    }
  }, [_c('i', [_vm._v("Philia ")]), _vm._v("takes up residence somewhere between "), _c('i', [_vm._v("storge")]), _vm._v(" and "), _c('i', [_vm._v("agape")]), _vm._v(", and if there were an English word for it, that word would be "), _c('i', [_vm._v("companionship")]), _vm._v(". It is about an abiding affection for the other. Yes, it is about loving, but it’s just as much about "), _c('i', [_vm._v("liking")]), _vm._v(". Unlike "), _c('i', [_vm._v("storge")]), _vm._v(", which happens spontaneously, "), _c('i', [_vm._v("philia")]), _vm._v(" happens "), _c('i', [_vm._v("intentionally")]), _vm._v(". A lot of hard work goes into truly liking someone who is totally different from you. "), _c('i', [_vm._v("Philia")]), _vm._v(" is about giving and receiving. It’s about "), _c('i', [_vm._v("mutual")]), _vm._v(" sacrifice. It is about real-world love, the kind you have to fight for. It’s about doing life together until our lives are woven together.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-16"
    }
  }, [_vm._v("As I stood there in the doorway with my wife, recalling our Gettysburg, I wondered if one of the subtle but fatal flaws in modern marriage is that we keep demanding from it the perfectness of "), _c('i', [_vm._v("agape")]), _vm._v(", when what it has always demanded from us is the tenderness of "), _c('i', [_vm._v("philia")]), _vm._v(". What if God has got "), _c('i', [_vm._v("agape")]), _vm._v(" covered and he gave us each other to bring a little more "), _c('i', [_vm._v("philia")]), _vm._v(" into the world? It made me think about that breakfast scene in the Bible, sometime shortly after Jesus disappeared from his tomb. It’s early morning and the disciples have been fishing. They’re catching nothing, when this man they fail to recognize as Jesus shows up on the distant shore and tells them to cast their nets on the other side of the boat. Instantly, their nets are full. This has happened before, and now they recognize the man who gave the order. They return to shore and enjoy a bountiful breakfast together. As the meal is concluding, Jesus asks Peter three times if Peter loves him. The first two times Jesus uses the word "), _c('i', [_vm._v("agape")]), _vm._v(". Peter says yes, but his answer does not satisfy Jesus. The third time Jesus asks the question—the time "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-17"
    }
  }, [_vm._v("he is satisfied by Peter’s answer—he uses the word "), _c('i', [_vm._v("philia")]), _vm._v(". Am I your "), _c('i', [_vm._v("companion")]), _vm._v(", Peter?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-17"
    }
  }, [_vm._v("What if marriage specifically—and companionship in general—is asking us to love each other, but it’s asking in the language of "), _c('i', [_vm._v("philia")]), _vm._v("?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-17"
    }
  }, [_vm._v("I was standing there in the doorway, noticing a soccer jersey I thought Quinn had lost months ago, when I began to wonder what it would look like if my wife and I gave our lives to "), _c('i', [_vm._v("philia")]), _vm._v(", to the daily practice of journeying through life alongside each other, witnessing this whole crazy, mysterious, beautiful, sorrowful, messy, terrifying thing together, not as flawless partners but as true companions. Earlier in the day, I’d shared with her my thoughts about "), _c('i', [_vm._v("agape")]), _vm._v(" and "), _c('i', [_vm._v("philia")]), _vm._v(". So as we stood there, two traveling companions witnessing together the chaos we are journeying through, I looked at her and asked, “"), _c('i', [_vm._v("Philia?")]), _vm._v("” She looked up at me and smiled.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-17"
    }
  }, [_vm._v("“Yes,” she said, “"), _c('i', [_vm._v("philia")]), _vm._v(".”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-17"
    }
  }, [_vm._v("If you are married and wanting your marriage to heal, or simply wanting to take your marriage to the next level, that level probably isn’t "), _c('i', [_vm._v("agape")]), _vm._v(". It’s probably "), _c('i', [_vm._v("philia")]), _vm._v(". If you’ve had difficulty your whole life putting words to why your brother or your sister feels like your best friend, that word probably isn’t "), _c('i', [_vm._v("storge")]), _vm._v(". The word is "), _c('i', [_vm._v("philia")]), _vm._v(". If you’ve spent most of your life in the pursuit of "), _c('i', [_vm._v("eros")]), _vm._v(", and it has always left you hungry for more, the word for the more you are hungering for is probably "), _c('i', [_vm._v("philia")]), _vm._v(". If you’re willing to work for it—risk for it, struggle for it, surrender for it—there is a companionship that awaits all of us, in our marriages and families and friendships. "), _c('i', [_vm._v("Philia")]), _vm._v("?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-17"
    }
  }, [_vm._v("Yes, "), _c('i', [_vm._v("philia")]), _vm._v(".")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-17"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  })]), _c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-17"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-18"
    }
  }, [_vm._v("AND ONE MORE THING ABOUT THIS BOOK")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-18"
    }
  }, [_vm._v("I’d tell all of this to my very brave and somewhat foolish younger self. Then, he’d walk away, into the rest of his day, into the rest of his life. He has just completed his master’s thesis on marital conflict. A year from now, he will coauthor a textbook chapter reviewing all the research that has ever been done about marital happiness and unhappiness. Two years after that, he will complete his doctoral dissertation about communication in marriage. Then, a year later, he will graduate, and armed with all this data about relationships, he will begin his career as a couples therapist. However, it will take fourteen more years of life and work and study before he has his most important insight of all:")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-18"
    }
  }, [_vm._v("When it comes to true companionship, all the textbooks in the world are outweighed by a butterfly.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-18"
    }
  }, [_vm._v("At first, the idea will seem very unscientific to him. However, the more he contemplates it, the more confident he will become about it: the three most poignant stages of a butterfly’s life have something essential to teach every aspiring companion about the three most important tasks of true companionship. So, he’ll write a book about "), _c('i', [_vm._v("philia")]), _vm._v(", with each part of the book focused on one of these stages and one of these tasks.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-18"
    }
  }, [_vm._v("Part one, “Grow Quiet: Befriending Your Loneliness,” explores the paradoxical prerequisite for true companionship: the ability to be lonely. We tend to resist loneliness, believing it to be a bad thing, but a butterfly "), _c('i', [_vm._v("chooses")]), _vm._v(" its loneliness as a "), _c('i', [_vm._v("necessary")]), _vm._v(" thing. Early in its life, while still a homely caterpillar, it enters into the solitary interior of a chrysalis to undergo a transformation. We, too, must choose our loneliness as the space in which we are formed into something mature enough "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-19"
    }
  }, [_vm._v("for companionship. Lonely things, if they can befriend their loneliness, grow into lovely things. In the quiet, we become.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-19"
    }
  }, [_vm._v("Part two, “Grow Strong: Embracing Your Struggle,” challenges our assumption about the core struggle in every companionship. It is not primarily "), _c('i', [_vm._v("between")]), _vm._v(" two people but "), _c('i', [_vm._v("within")]), _vm._v(" each person. Every butterfly’s life is defined not by a struggle with another butterfly but by a struggle with its own protection. When it is ready to join its companions, it must push its way out of its once protective but now imprisoning chrysalis. It’s a challenging struggle, but only through this process does a butterfly strengthen its wings enough to fly. Similarly, in true companionship, we are in an ongoing struggle to push our way out of our own protections. Gradually, in the midst of this struggle, we grow strong enough to love. That’s how companionship forms us into flying things.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-19"
    }
  }, [_vm._v("Part three, “Grow Old: Cherishing Your Time,” invites us to cherish that which we often fear: the passage of time and our mortality. The butterfly’s life beyond the cocoon usually lasts only a few weeks. Butterflies are lovely things, they are flying things, and they are also dying things. So are we. However, unlike the butterfly, we are the only creatures on the planet who can grieve the loss of life before it happens, so we are the only creatures who can live our lives together as an act of cherishing what will soon be gone. When we bravely accept the end rather than resisting it, we clarify our priorities, sharpen our focus, and love our companions with a little more urgency, while we still have time. Numbered days are cherished days.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-19"
    }
  }, [_vm._v("“We’re all just walking each other home,” writes philosopher Ram Dass. For the remainder of these pages, you and I will be "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  })]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-20"
    }
  }, [_vm._v("walking toward home together, so there are a couple of things you need to know about this leg of the journey. First, each of the three parts of this book begins and ends with a letter to my wife. Second, she’s the bravest person I know—brave enough to let me share with you these windows into our companionship. Third, you should probably know her name is Kelly as well. Yes, this is weird and confusing, especially to airport security. So, to eliminate some of the confusion, I’ve addressed her letters to “M.” That is my nickname for her. It stands for “Miracle,” because she is my miracle. So much of true companionship—before and after all the hard work—feels like that.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-20"
    }
  }, [_vm._v("Whether you are single and planning to stay that way, dating and in no rush to be anything else, engaged to the one you’ve chosen, happily married, angrily fighting, contemplating separation, recovering from divorce, getting remarried, walking through widowhood, confused about how to become a better parent or child or aunt or uncle or sibling or cousin, longing to become a more faithful friend, or waiting upon a friend who can be truly faithful to you, I hope in the singular light of these pages, you will glimpse the great, general light of companionship.")])])])])])])]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "r-20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0